import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  DEAL_COLLECTION_SLUGS,
  dealsPath,
  type DealCollectionSlug,
  type StoreOption,
} from './dealFilters';

const COLLECTION_LABEL_KEYS: Record<DealCollectionSlug, string> = {
  latest: 'deals.latest_link',
  'expiring-soon': 'deals.expiring_soon_link',
  'promo-codes': 'deals.promo_codes_link',
  '20-off': 'deals.discount_link',
  '40-off': 'deals.discount_link',
  '60-off': 'deals.discount_link',
};

const COLLECTION_PCTS: Partial<Record<DealCollectionSlug, number>> = {
  '20-off': 20,
  '40-off': 40,
  '60-off': 60,
};

const linkClass =
  'max-w-max px-1 font-secondary text-base font-semibold leading-[25.6px] text-primary-dark transition-all hover:text-primary active:scale-[97%]';

type Props = {
  currentSlug?: string | null;
  stores?: StoreOption[];
};

export const DealsSeoLinks = ({ currentSlug = null, stores = [] }: Props) => {
  const { t } = useTranslation();

  return (
    <nav aria-label={t('deals.browse')} className='mt-8 flex flex-col gap-4 border-t border-black/10 pt-6'>
      <h2 className='heading-200 text-primary-dark'>{t('deals.browse')}</h2>
      <div className='flex flex-wrap gap-x-4 gap-y-2'>
        <Link to='/deals' className={linkClass} aria-current={currentSlug == null ? 'page' : undefined}>
          {t('deals.all_link')}
        </Link>
        {DEAL_COLLECTION_SLUGS.map((slug) => {
          const pct = COLLECTION_PCTS[slug];
          return (
            <Link
              key={slug}
              to={dealsPath(slug)}
              className={linkClass}
              aria-current={currentSlug === slug ? 'page' : undefined}
            >
              {t(COLLECTION_LABEL_KEYS[slug], pct != null ? { pct } : undefined)}
            </Link>
          );
        })}
      </div>
      {stores.length > 0 && (
        <>
          <h3 className='heading-200 text-primary-dark'>{t('deals.popular_stores')}</h3>
          <div className='flex flex-wrap gap-x-4 gap-y-2'>
            {stores.map((store) => (
              <Link
                key={store.slug}
                to={dealsPath(store.slug)}
                className={linkClass}
                aria-current={currentSlug === store.slug ? 'page' : undefined}
              >
                {t('deals.store_link', { store: store.label })}
              </Link>
            ))}
          </div>
        </>
      )}
    </nav>
  );
};
